// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MailOutlinedSvg from "@ant-design/icons-svg/es/asn/MailOutlined";
import AntdIcon from '../components/AntdIcon';

var MailOutlined = function MailOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MailOutlinedSvg
  }));
};

MailOutlined.displayName = 'MailOutlined';
export default React.forwardRef(MailOutlined);